export const SET_LOGIN = "SET_LOGIN";
export const UPDATE_IS_LOGIN = "UPDATE_IS_LOGIN";

export const SET_ACTIVE_STEP = "SET_ACTIVE_STEP";
export const SET_OTP_VERIFICATION = "SET_OTP_VERIFICATION";
export const UPDATE_LOADING = "UPDATE_LOADING";
export const UPDATE_SUMMARY = "UPDATE_SUMMARY";
export const SHOW_ERROR_MESSAGE = "SHOW_ERROR_MESSAGE";
export const UPDATE_WELCOME_KIT_DETAILS = "UPDATE_WELCOME_KIT_DETAILS";
export const SET_POLICY_TYPE = "SET_POLICY_TYPE";
export const SET_CLAIM_POLICY = "SET_CLAIM_POLICY";
export const HAS_EXPOSURE = "HAS_EXPOSURE";
export const SET_OTHER_INFO = "SET_OTHER_INFO";
export const SET_DEC_DATA = "SET_DEC_DATA";
export const SET_JWT = "SET_JWT";
export const SET_REQUEST_ID = "SET_REQUEST_ID";
